export const WATERSHED_DETAILS_TAB_ID = "LRS-Details";